import axios from 'axios';
import Env from '~/env';

const HUB_SITE =
  Env.ENV_NAME === 'hml'
    ? 'https://hubhml.cldmar.com.br'
    : 'https://hub.cldmar.com.br';

export async function getIpv4UseCase(): Promise<string | null> {
  try {
    const response = await axios.get(`${HUB_SITE}/remote_addr`, {
      timeout: 1000,
    });

    return response.data.ip;
  } catch {
    return null;
  }
}
